import { useId } from 'react';
import type { IconProps } from '@src/components/icons/IconProps';

/** American flag, simplified for a 1em mark. Colours are the flag, not tokens. */
export function UsFlagIcon({ className }: IconProps) {
  const clipId = useId();

  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <clipPath id={clipId}>
          <rect x="2" y="6" width="20" height="12" rx="1.5" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <rect x="2" y="6" width="20" height="12" fill="#b22234" />
        <rect x="2" y="7.7" width="20" height="1.7" fill="#fff" />
        <rect x="2" y="11.15" width="20" height="1.7" fill="#fff" />
        <rect x="2" y="14.6" width="20" height="1.7" fill="#fff" />
        <rect x="2" y="6" width="8.5" height="6.5" fill="#3c3b6e" />
      </g>
    </svg>
  );
}
